/* eslint-disable no-unused-vars */ /* eslint-disable react/prop-types */ import React, {  useState,
  useEffect,
} from 'react';
import Grid from '@material-ui/core/Grid';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import locale from 'date-fns/locale/pt-BR';
import DateFnsUtils from '@date-io/date-fns';
import ReportTable from './ReportTable';
import api from '../../../../service/axios/api';
import TableTop from './TableTop';

export default function Daile({ setLoading, setMsg }) {
  const [data, setData] = useState([]);
  const [dataTop, setDataTop] = useState([]);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [itens, setItens] = useState(10);

  const [selectedStartDate, handleStartDateChange] = useState(new Date());
  const [selectedEndDate, handleEndDateChange] = useState(new Date());

  const templateDownload = () => {
    setMsg(
      `Gerando planilha, isso pode levar alguns ${
        total > 100000 ? 'minutos' : 'segundos'
      }...`,
    );
    setLoading(true);
    api.order
      .summaryDayXls(
        selectedStartDate.toISOString(),
        selectedEndDate.toISOString(),
      )
      .then(res => {
        const url = res.retorno.link;
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'movimentacao.xlsx');
        document.body.appendChild(link);
        link.click();
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setMsg('Processando dados do período, isso pode levar alguns segundos...');
    setLoading(true);
    api.order
      .summaryDay(
        selectedStartDate.toISOString(),
        selectedEndDate.toISOString(),
        page + 1,
        itens,
      )
      .then(res => {
        setData(res.data.retorno.details);
        setTotal(res.data.retorno.totalDetails);
        setDataTop(res.data.retorno.topCategories);
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [selectedStartDate, selectedEndDate, page, itens]);

  return (
    <>
      <Grid
        item
        xs={12}
        sm={12}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100% ',
        }}
      >
        <h3>Movimentação por período</h3>
        <div style={{ display: 'flex', flexDirection: 'row', gap: '5px' }}>
          <div>
            <h6>Data início</h6>
            <MuiPickersUtilsProvider
              locale={locale}
              utils={DateFnsUtils}
              style={{ float: 'right ' }}
            >
              <KeyboardDatePicker
                autoOk
                variant="inline"
                maxDate={selectedEndDate || new Date()}
                inputVariant="outlined"
                style={{ backgroundColor: '#fff' }}
                size="small"
                format="dd/MM/yyyy"
                InputProps={{ readOnly: true }}
                InputAdornmentProps={{ position: 'start' }}
                value={selectedStartDate}
                onChange={date => {
                  handleStartDateChange(date);
                  setPage(0);
                }}
              />
            </MuiPickersUtilsProvider>
          </div>
          <div>
            <h6>Data fim</h6>
            <MuiPickersUtilsProvider
              locale={locale}
              utils={DateFnsUtils}
              style={{ float: 'right ' }}
            >
              <KeyboardDatePicker
                autoOk
                variant="inline"
                minDate={selectedStartDate}
                maxDate={new Date()}
                inputVariant="outlined"
                style={{ backgroundColor: '#fff' }}
                size="small"
                format="dd/MM/yyyy"
                InputProps={{ readOnly: true }}
                InputAdornmentProps={{ position: 'start' }}
                value={selectedEndDate}
                onChange={date => {
                  handleEndDateChange(date);
                  setPage(0);
                }}
              />
            </MuiPickersUtilsProvider>
          </div>
        </div>
      </Grid>
      <Grid item xs={12} sm={12} style={{ marginBottom: '20px' }}>
        <h1
          style={{
            fontSize: '20px',
            marginTop: '20px',
            color: '#bbbbbd',
            fontStyle: 'italic',
          }}
        >
          Maiores receitas do período
        </h1>
        <div style={{ display: 'inline-block', width: '100%' }}>
          <TableTop docs={dataTop} />
        </div>
      </Grid>

      <Grid style={{ marginBottom: '20px', marginLeft: '10px', width: '100%' }}>
        <h1
          style={{
            fontSize: '20px',
            marginTop: '20px',
            color: '#bbbbbd',
            fontStyle: 'italic',
          }}
        >
          Receitas do período
        </h1>
        <ReportTable
          docs={data}
          page={page}
          setPage={setPage}
          itens={itens}
          setItens={setItens}
          total={total}
          getXls={templateDownload}
        />
      </Grid>
    </>
  );
}
